
<ion-modal #modalReportAbuse>
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="end">
          <ion-button (click)="dismiss()" [strong]="true">{{ 'Close' | translate }}</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding #content>
      <ion-item lines="none">
        <ion-label class="ion-text-wrap">{{ 'Report abuse' | translate }}</ion-label>
      </ion-item>
      <ion-item lines="none">
        <ion-label class="ion-text-wrap">{{ 'You are about to report abuse regarding the following text:' | translate }}</ion-label>
      </ion-item>
      <ion-item lines="none">
        <ion-label class="ion-text-wrap" [innerHTML]="msg"></ion-label>
      </ion-item>
    </ion-content>
    <ion-footer>
      <ion-toolbar style="padding-top: 0; padding-left: 0; padding-right: 0;">
        <ion-buttons slot="start">
          <ion-button (click)="dismiss()" [strong]="true">{{ 'Close' | translate }}</ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button (click)="send()" [strong]="true"><ion-icon name="rocket"></ion-icon><ion-label>{{ 'Send' | translate }}</ion-label></ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-footer>
  </ng-template>
</ion-modal>